import { USER_ASSIGNMENT_ACTION_TYPE } from '../../../common/constants'

import { DEFAULT_MENU_CURATION_TASK_LIST_FILTERS } from '../../constants'

const MENU_CURATION_TASKS_INITIAL_STATE = {
  isLoading: false,
  error: undefined,
  data: undefined,
  userAssignation: {
    [USER_ASSIGNMENT_ACTION_TYPE.TIER_ONE]: {},
    [USER_ASSIGNMENT_ACTION_TYPE.CURATION]: {},
    [USER_ASSIGNMENT_ACTION_TYPE.QA]: {},
    [USER_ASSIGNMENT_ACTION_TYPE.QC]: {},
    [USER_ASSIGNMENT_ACTION_TYPE.UNKNOWN_WORDS_CURATION]: {},
    [USER_ASSIGNMENT_ACTION_TYPE.UNKNOWN_WORDS_QA]: {},
  },
  persistedFilters: {
    taskStatus: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.TASK_STATUS,
    isTierOneDone: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_TIER_ONE_DONE,
    isCurationDone: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_CURATION_DONE,
    isQaDone: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_QA_DONE,
    isQcDone: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_QC_DONE,
    isUnknownWordsCurationDone:
      DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_UNKNOWN_WORDS_CURATION_DONE,
    isUnknownWordsQaDone:
      DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.IS_UNKNOWN_WORDS_QA_DONE,
    searchText: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.SEARCH,
    assignedTierOneCurator:
      DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.ASSIGNED_TIER_ONE_CURATOR,
    assignedCurator: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.ASSIGNED_CURATOR,
    assignedQa: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.ASSIGNED_QA,
    assignedQc: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.ASSIGNED_QC,
    languageIds: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.LANGUAGE_IDS,
    duplicate: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.DUPLICATE,
    isAutomaticAllocationLoading: false,
    automaticAllocationError: undefined,
  },
  priorityTaskProgressCounts: undefined,
  nonUrlFilters: {
    autoeatStatus: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.AUTOEAT_STATUS,
    tags: DEFAULT_MENU_CURATION_TASK_LIST_FILTERS.TAGS,
  },
}

export default MENU_CURATION_TASKS_INITIAL_STATE
